<template>
  <div ref="form" class="pass">
    <div class="gauche">
      <slot name="title"></slot>

      <div class="messagePremium">
        <slot name="description"></slot>
      </div>

      <div class="passList">
        <PassBoxes
          v-if="products && selectedProduct"
          :products="products"
          :refprice="products[products.length - 1].monthlyPrice"
          :prorata="prorata"
          v-model="selectedProduct"
        >
        </PassBoxes>
      </div>
    </div>

    <div class="aah" v-if="aahProducts">
      <input id="aahSelected" type="checkbox" v-model="aah" />
      <label for="aahSelected"> Je suis bénéficiaire de l'<strong>AAH</strong> (jusqu'à 20% de réduction). </label>
    </div>

    <p class="recond">
      Votre Pass sera renouvelé à automatiquement échéance
      <span v-if="selectedProduct.initialPrice == null"
        >pour une période équivalente à celle souscrite initialement</span
      >. Vous pouvez annuler ce renouvellement sur la page « Mon Compte »
    </p>
    <div class="boutons formule" v-if="selectedProduct">
      <a v-if="products.length >= 2" class="bouton choisir" @click.prevent="choixForumule"
        >Choisir le {{ selectedProduct.name }}</a
      >
      <a v-else class="bouton choisir" @click.prevent="choixForumule">Souscrire</a>
    </div>
  </div>
</template>

<script>
import { idyuMobileMode } from "@/assets/js/idyu/util.js";
import PassBoxes from "../pass/PassBoxes.vue";

export default {
  name: "PassChoice",
  components: { PassBoxes },
  props: ["normalProducts", "aahProducts", "prorata", "promo"],

  data() {
    return {
      selectedProduct: null,
      aah: false
    };
  },

  created() {
    this.initSelection();
  },

  methods: {
    initSelection() {
      if (!this.products) {
        return;
      }

      let preselect = 2;
      if (this.selectedProduct) {
        preselect = this.selectedProduct.code;
      }

      for (let prd of this.products) {
        if (prd) {
          if (prd.code === preselect) {
            this.selectedProduct = prd;
            break;
          }
        }
      }

      if (!this.selectedProduct) {
        this.selectedProduct = this.products[0];
      }
    },

    passClicked: function(pass) {
      for (let pass of this.$refs.pass) {
        pass.boxClass.selected = false;
      }
      this.selectedProduct = pass;
    },

    choixForumule() {
      this.$router.push({ name: "payment", query: { id: this.selectedProduct.id } });
    }
  },

  computed: {
    products() {
      if (this.aah) {
        return this.aahProducts;
      }
      return this.normalProducts;
    },

    refPrice: function() {
      return this.products[this.products.length - 1].price;
    },

    selectedValue: function() {
      if (this.selectedProduct != null) {
        return this.selectedProduct.id;
      }
      return 0;
    },

    mobileMode: function() {
      return idyuMobileMode(this.$store);
    }
  },

  watch: {
    aah() {
      this.initSelection();
    },

    normalProducts() {
      this.initSelection();
    },

    aahProducts() {
      this.initSelection();
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/vars.scss";

form {
  display: none;
}

.messagePremium {
  font-size: 18px;
  margin-top: 10px;
  img {
    vertical-align: middle;
    margin-right: 5px;
  }
  display: grid;
  grid-gap: 10px;
}

.recond.mobile {
  display: none;
}

.recond {
  font-size: 14px;
}

.passList {
  display: grid;
  margin-top: 10px;
}

h2 {
  color: black;
  margin: 0;
}

h3 {
  margin: 0;
  margin-top: 10px;
  color: $theme_color;
}
.choisir {
  color: white;
  background-color: #0c4da1;
}
.formule {
  margin-top: 10px;
}

.recond {
  border-top: 1px gray dotted;
  padding-top: 5px;
}

.aah {
  border-top: 1px gray dotted;
  padding-top: 10px;
}
</style>
